<template>
  <div :id="id" :data-modal-id='id' class="ui modal" :class="size_class">
    <div class="header">
      <span v-if="!hide_cancel" class="actions">
        <a class="cancel">
          <i class="times icon"></i>
        </a>
      </span>
      {{ title }}
    </div>
    <div class="content" :class="{ scrolling: scrollable }">
      <slot>{{ message }}</slot>
    </div>
    <div v-if="!hide_footer" class="actions">
      <div v-if="!hide_cancel" class="ui black deny button" @click="$emit('cancel')">
        取消
      </div>
      <div v-if="!hide_ok" class="ui positive button" @click="$emit('ok')">
        <template v-if="okTitle">{{ okTitle }}</template>
        <template v-else>确认</template>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'Modal',
  props: ['id', 'size', 'okTitle', 'title', 'message', 'hide_footer', 'scrollable', 'hide_ok', 'hide_cancel'],
  components: {
  },
  data: function () {
    return {
    };
  },
  computed: {
    size_class() {
      if (this.size) {
        return [this.size];
      }
      return [];
    },
  },
  methods: {
  },
  created() {
    this.$(".ui.dimmer [data-modal-id=" + this.id + "]").remove();
  },
}
</script>

<style scoped>
</style>

